import { render, staticRenderFns } from "./Crear.vue?vue&type=template&id=56ab1b16"
import script from "./Crear.vue?vue&type=script&lang=js"
export * from "./Crear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ab1b16')) {
      api.createRecord('56ab1b16', component.options)
    } else {
      api.reload('56ab1b16', component.options)
    }
    module.hot.accept("./Crear.vue?vue&type=template&id=56ab1b16", function () {
      api.rerender('56ab1b16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/usuario/Crear.vue"
export default component.exports